import React from "react";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const PrivacyPolicyModal: React.FC<PrivacyPolicyModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-gray-800 rounded-lg max-w-4xl max-h-[90vh] overflow-y-auto dropdown-scrollbar">
        <div className="sticky top-0 bg-gray-800 border-b border-gray-700 px-6 py-4 flex justify-between items-center">
          <h2 className="text-2xl font-bold text-white">
            {t("1177", "Privacy Policy")}
          </h2>
          <button
            onClick={onClose}
            aria-label={t("1178", "Close privacy policy")}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <div className="px-6 py-6 space-y-6">
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">
              {t("1179", "Data Collection and Usage")}
            </h3>
            <p className="text-gray-300 leading-relaxed">
              {t(
                "1180",
                "We use various forms on this website to provide you with our services. The data you submit through these forms is not stored permanently on our website. If your form submission results in a business transaction, we are legally required to retain this information for 7 years as mandated by Dutch law. We do not share this information with third parties, except where legally required to do so by applicable regulations or court orders."
              )}
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-white mb-3">
              {t("1181", "Contact Information Storage")}
            </h3>
            <p className="text-gray-300 leading-relaxed">
              {t(
                "1182",
                "When you contact us through our forms or phone, we may store your contact details temporarily to respond to your inquiry and provide quotes. This information is deleted after completion of the service or after 30 days if no booking is made."
              )}
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-white mb-3">
              {t("1183", "Cookies and Website Analytics")}
            </h3>
            <p className="text-gray-300 leading-relaxed">
              {t(
                "1184",
                "Our website uses essential cookies for functionality and may use analytics cookies to improve our services. You can control cookie preferences through your browser settings."
              )}
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-white mb-3">
              {t("1185", "Your Rights")}
            </h3>
            <p className="text-gray-300 leading-relaxed">
              {t(
                "1186",
                "Under GDPR, you have the right to access, correct, or delete your personal data. Contact us at info@taxischipholairport.net for any privacy-related requests."
              )}
            </p>
          </section>
        </div>

        <div className="sticky bottom-0 bg-gray-700 px-6 py-4 border-t border-gray-600">
          <button
            onClick={onClose}
            className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary-dark transition-colors"
          >
            {t("1187", "Close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
